import { defineComponent as S, ref as U, inject as P, computed as s, openBlock as r, createElementBlock as l, normalizeClass as E, createElementVNode as a, withDirectives as M, vShow as T, createCommentVNode as i, toDisplayString as o, createBlock as I, resolveDynamicComponent as Y, unref as n, createTextVNode as v, Fragment as F, renderList as O } from "vue";
import { useDateFormat as q } from "@vueuse/core";
import { $ as L } from "./chunks/FrontiersClibConfigService.5b50b8d0.js";
import { a as $ } from "./chunks/Numbers.0dd1fb08.js";
import './assets/index21.css';const G = ["href", "data-event"], J = { class: "CardArticle__mask CardArticle__mask--hzt" }, K = ["src", "alt"], Q = { class: "CardArticle__info" }, R = {
  key: 0,
  class: "CardArticle__pdfLabel"
}, W = { class: "CardArticle__header" }, X = { class: "CardArticle__type" }, Z = { class: "CardArticle__date" }, x = {
  key: 1,
  class: "CardArticle__section"
}, ee = { class: "CardArticle__authors notranslate" }, te = ["innerHTML"], ae = ["innerHTML"], se = /* @__PURE__ */ a("div", { class: "CardArticle__spacer" }, null, -1), re = { class: "CardArticle__mask CardArticle__mask--vrt" }, le = ["src", "alt"], oe = { class: "CardArticle__journal" }, ie = ["innerHTML"], ne = {
  key: 0,
  class: "CardArticle__journal__doi notranslate"
}, ce = { class: "CardArticle__metrics" }, ue = {
  key: 0,
  class: "CardArticle__metrics__item"
}, de = {
  key: 1,
  class: "CardArticle__metrics__item"
}, C = 10, ve = /* @__PURE__ */ S({
  __name: "CardArticle",
  props: {
    id: {},
    doi: {},
    title: {},
    type: {},
    publishedDate: {},
    acceptedDate: {},
    journalName: {},
    journalSlug: {},
    useNewUrl: { type: Boolean },
    section: {},
    authors: {},
    totalViews: {},
    totalCitations: {},
    imageUrl: {},
    showPdfTag: { type: Boolean },
    skin: {},
    heading: { default: "h3" }
  },
  setup(N) {
    const t = N, g = U(!1), u = P("sanitize"), A = (e, d, c = "s") => `${e}${d !== 1 ? c : ""}`, H = s(() => {
      const e = t.publishedDate ? t.publishedDate : t.acceptedDate, d = t.publishedDate ? "Published" : "Accepted", c = q(e, "DD MMM YYYY");
      return `${d} on ${c.value}`;
    }), f = s(() => t.totalViews ? t.totalViews >= 100 : !1), w = s(() => t.totalCitations ? t.totalCitations > 0 : !1), j = s(() => !t.publishedDate && !!t.acceptedDate), V = s(() => t.useNewUrl && t.journalSlug ? `https://www.${L.getMainDomain}/journals/${t.journalSlug}/articles/${t.doi}/full` : `https://www.${L.getMainDomain}/articles/${t.doi}/full`), _ = s(() => !!(t.imageUrl && g.value)), b = s(() => !!(f.value || w.value)), z = s(() => {
      const e = ["CardArticle"];
      return _.value && e.push("CardArticle--hasImg"), b.value && e.push("CardArticle--hasMetrics"), D.value && e.push("CardArticle--horizontal"), e;
    }), D = s(() => t.skin === "Horizontal"), h = s(() => {
      var e;
      return ((e = t.authors) == null ? void 0 : e.length) > C;
    }), m = s(() => {
      var e;
      return h.value ? ((e = t.authors) == null ? void 0 : e.length) - C : 0;
    }), p = s(() => h.value ? t.authors.slice(0, C - 1) : t.authors), k = s(() => h.value ? t.authors[t.authors.length - 1] : null), y = () => {
      g.value = !0;
    };
    return (e, d) => (r(), l("article", {
      class: E(z.value)
    }, [
      a("a", {
        class: "CardArticle__wrapper",
        href: V.value,
        "data-event": e.$ga.getDataEventValue("cardArticle", "a", e.doi)
      }, [
        M(a("figure", J, [
          a("img", {
            class: "CardArticle__mask__img",
            src: e.imageUrl,
            alt: e.title,
            onLoad: y
          }, null, 40, K)
        ], 512), [
          [T, _.value && D.value]
        ]),
        a("div", Q, [
          e.showPdfTag ? (r(), l("p", R, "PDF-read only")) : i("", !0),
          a("div", W, [
            a("p", X, o(e.type), 1),
            a("p", Z, o(H.value), 1)
          ]),
          (r(), I(Y(e.heading), {
            class: "CardArticle__title",
            innerHTML: n(u)(e.title)
          }, null, 8, ["innerHTML"])),
          e.section ? (r(), l("p", x, [
            v(" in "),
            a("span", null, o(e.section), 1)
          ])) : i("", !0),
          a("ul", ee, [
            (r(!0), l(F, null, O(p.value, (c, B) => (r(), l("li", {
              key: B,
              innerHTML: n(u)(c.fullName)
            }, null, 8, te))), 128)),
            m.value ? (r(), l("li", {
              key: p.value.length + m.value,
              class: "CardArticle__authors__more"
            }, o(m.value) + " more ", 1)) : i("", !0),
            k.value ? (r(), l("li", {
              key: p.value.length,
              innerHTML: n(u)(k.value.fullName)
            }, null, 8, ae)) : i("", !0)
          ]),
          se,
          M(a("figure", re, [
            a("img", {
              class: "CardArticle__mask__img",
              src: e.imageUrl,
              alt: e.title,
              onLoad: y
            }, null, 40, le)
          ], 512), [
            [T, _.value]
          ]),
          a("div", oe, [
            a("div", {
              class: "CardArticle__journal__name",
              innerHTML: n(u)(e.journalName)
            }, null, 8, ie),
            j.value ? i("", !0) : (r(), l("div", ne, o(`doi ${e.doi}`), 1))
          ])
        ]),
        a("ul", ce, [
          f.value ? (r(), l("li", ue, [
            a("strong", null, o(n($)(e.totalViews)), 1),
            v(" " + o(A("view", e.totalViews)), 1)
          ])) : i("", !0),
          w.value ? (r(), l("li", de, [
            a("strong", null, o(n($)(e.totalCitations)), 1),
            v(" " + o(A("citation", e.totalCitations)), 1)
          ])) : i("", !0)
        ])
      ], 8, G)
    ], 2));
  }
});
export {
  ve as CardArticle
};
